import type { LDFlagSet } from '@nx/launch-darkly-service';
import type { BaseMetricsRequest, MetricsRequestType, MetricsResponse, MetricsResult, SeriesSummary } from '@nx/state';
import type { JSX } from 'react';
import type { Options } from 'react-select';
import type uPlot from 'uplot';

import type { ChartType, ChartWidgetPartialProps } from '../charts/fullstack-chart-props';
import type { MultiChartProps } from '../charts/types';

export type DropdownOption<TValue = string> = { value: TValue; label: string };

export type DropdownOptions<TValue = string> = Options<DropdownOption<TValue>>;

export type TooltipComponentType = (props: {
  cursorIdx: number;
  uPlotInstance: uPlot;
  seriesSummary: SeriesSummary[];
}) => JSX.Element | null;

export type YUplotValue = null | undefined | number;

export abstract class MetricSource {
  constructor(
    public tenantId: string,
    public dbmsId: string,
    public name: string,
    public database?: string,
  ) {}

  abstract getCharts(flags: LDFlagSet): Record<ChartType, MultiChartProps[]>;

  abstract isCmiAvailable(): boolean;

  abstract getPills(chartProps: MultiChartProps, metrics: MetricsResult['metrics']): SeriesSummary[];

  abstract createMetricsRequest(
    startTime: number,
    endTime: number,
    chartType: ChartType,
    chartProps: MultiChartProps[],
  ): { metricsRequest: BaseMetricsRequest; type: MetricsRequestType };

  abstract mapMetrics(
    metrics: MetricsResponse,
    chartProps: MultiChartProps[],
    seriesNameMapper?: (props: ChartWidgetPartialProps) => string,
  ): MetricsResult['metrics'];
}
